import styles from './index.module.less'
import classNames from 'classnames'
import { forwardRef, useImperativeHandle } from 'react'
import { useSetState } from 'ahooks'

export const ExplainInput = forwardRef((props: any, ref) => {
  const {
    name,
    suffix,
    style,
    placeholder,
    onChange,
    onPressEnter,
    onBlur,
    error = {},
    value,
    rules,
    ...rest
  } = props

  const [state, setState] = useSetState({
    error: {},
  })

  const resetError = () => {
    setState({ error: {} })
  }
  const validate = async (val = value) => {
    return Promise.all(
      rules?.map?.(ruleFn => {
        const rule = ruleFn()
        return rule.validator?.(null, val)
      })
    )
      .then(() => {
        resetError()
        Promise.resolve()
      })
      .catch(err => {
        state.error[name] = err
        setState({ error: state.error })
        return Promise.reject(err)
      })
  }

  const handleBlur = e => {
    onBlur?.(e)
    if (Array.isArray(rules) && rules.length) {
      validate(e.target.value)
    } else {
      setState({ error: {} })
    }
  }

  useImperativeHandle(ref, () => ({
    validate,
    resetError,
  }))

  const handleKeyDown = e => {
    if (e.code === 'Enter') {
      onPressEnter?.(e.target.value)
    }
  }
  const hasError = state.error[name] || error[name]
  const errTips = state.error[name] || ''
  return (
    <>
      <div className={styles.explainInput} style={style}>
        <div className={styles.inputWrap}>
          <input
            className={classNames(styles.loginInput, styles.suffixInput, hasError && styles.error)}
            placeholder={placeholder}
            onChange={e => onChange?.(e.target.value, name)}
            onKeyDown={handleKeyDown}
            onBlur={handleBlur}
            value={value}
            {...rest}
          />
          <div className={styles.suffix}>{suffix}</div>
        </div>
        {hasError ? (
          <div
            style={{
              display: 'flex',
              flexWrap: 'nowrap',
              // minHeight: style?.marginBottom
            }}
          >
            <div className={styles.explainError}>{errTips || placeholder || '字段必填'} </div>
            <div style={{ width: 0, height: style?.marginBottom || 24 }}></div>
          </div>
        ) : null}
      </div>

      {hasError ? (
        <div
          className={styles.formErrorOffset}
          style={{ marginTop: -style?.marginBottom || -24 }}
        ></div>
      ) : null}
    </>
  )
})
